import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2, Mail, Lock } from "lucide-react";
import Logo from "../components/Logo";
import { formatApiError } from "../lib/errors";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      nav("/app/dashboard");
    } catch (e2) {
      setErr(formatApiError(e2, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#E6F7F5] via-white to-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-xl border border-slate-100 p-8">
        <Link to="/" className="flex justify-center mb-6">
          <Logo size="lg" />
        </Link>
        <h1 className="text-2xl font-bold text-slate-800 text-center mb-2">Doctor Login</h1>
        <p className="text-center text-slate-500 text-sm mb-6">Manage your clinic, patients & appointments</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-9 pr-3 py-2.5 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0F2A5F] focus:border-transparent text-sm"
                placeholder="doctor@clinic.com"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-9 pr-3 py-2.5 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0F2A5F] focus:border-transparent text-sm"
                placeholder="••••••••"
              />
            </div>
          </div>

          {err && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2 rounded">
              {err}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            className="w-full bg-[#14B8A6] hover:bg-[#0F8A7D] disabled:opacity-70 text-white font-semibold uppercase tracking-wide py-2.5 rounded-md flex items-center justify-center gap-2 transition-colors"
          >
            {busy && <Loader2 size={16} className="animate-spin" />}
            Sign in
          </button>
        </form>

        <p className="text-center mt-4">
          <Link to="/forgot-password" className="text-sm text-slate-500 hover:text-[#0F2A5F] hover:underline">
            Forgot password?
          </Link>
        </p>

        <p className="text-center text-sm text-slate-600 mt-6">
          New here?{" "}
          <Link to="/register" className="text-[#0F2A5F] font-semibold hover:underline">
            Create account
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
